import { toastError } from "@/utils/helpers/toast-helper";
import { Right } from "@/type/core/offices/offices.types";
import BasicButton from "@components/core/buttons/BasicButton";
import { ROUTES } from "@routes/Routes";
import { TransactionDetail } from "@type/core/transaction/transaction.types";
import { TransactionHelper } from "@utils/helpers/transaction-helper";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface TransactionEditButtonProps {
  transaction: TransactionDetail;
  officeRights?: Right[];
  signatureRight: Right;
  scellementRight: Right;
  label: string;
  disabled: boolean;
  className?: string;
}

const TransactionEditButton: FunctionComponent<TransactionEditButtonProps> = ({
  transaction,
  officeRights,
  signatureRight,
  scellementRight,
  label,
  disabled,
  className = "",
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const signatureType = transaction && transaction.type === "signature";
  const scellementType = transaction && transaction.type === "scellement";

  const navigateRegardingTypes = () => {
    if (signatureType) {
      navigate(ROUTES.extranet.transactions.signature.generate());
    } else if (scellementType) {
      navigate(ROUTES.extranet.transactions.scellement.generate());
    } else {
      toastError(t("error.500"));
    }
  };

  if (
    (signatureType && officeRights?.includes(signatureRight)) ||
    (scellementType && officeRights?.includes(scellementRight))
  ) {
    return (
      <BasicButton
        variant="tertiary"
        disabled={disabled}
        text={label}
        onClick={() => {
          if (!disabled) {
            TransactionHelper.retrieveTransactionDetailAndSetItIntoStore(
              transaction.id,
              navigateRegardingTypes,
            );
          }
        }}
        className={`py-11 px-30 font-extra-small ${className}`}
      />
    );
  } else return null;
};

export default TransactionEditButton;
